// Exposes window.OctopusMarketo. Polls for MktoForms2 (loaded by marketoLoader.js)
// and provides initForm() + stripDefaultStyles() so callers share one implementation.
(function () {
    if (window.OctopusMarketo) return;

    var POLL_INTERVAL_MS = 200;
    var MAX_ATTEMPTS = 75; // 15 s total

    function whenReady(callback, onTimeout) {
        var attempts = 0;
        function tick() {
            if (typeof window.MktoForms2 !== "undefined") {
                callback(window.MktoForms2);
                return;
            }
            if (++attempts >= MAX_ATTEMPTS) {
                if (typeof onTimeout === "function") {
                    onTimeout();
                } else {
                    console.error("MktoForms2 did not load within " + (MAX_ATTEMPTS * POLL_INTERVAL_MS / 1000) + "s");
                }
                return;
            }
            setTimeout(tick, POLL_INTERVAL_MS);
        }
        tick();
    }

    function initForm(options) {
        whenReady(function (MktoForms2) {
            MktoForms2.loadForm(
                options.baseUrl || "//get.octopus.com",
                options.munchkinId,
                options.formId,
                function (form) {
                    if (typeof options.onFormReady === "function") {
                        options.onFormReady(form);
                    }
                }
            );
        }, options.onTimeout);
    }

    function stripDefaultStyles(formElem) {
        if (!formElem) return;
        var firstStyle = formElem.querySelector("style");
        if (firstStyle) firstStyle.remove();
        var baseStyle = document.getElementById("mktoForms2BaseStyle");
        if (baseStyle) baseStyle.remove();
    }

    window.OctopusMarketo = {
        whenReady: whenReady,
        initForm: initForm,
        stripDefaultStyles: stripDefaultStyles
    };
})();
